import axios from "axios";

import TokenService from "./TokenService";

const isDevelopment = process.env.NODE_ENV === "development";

const DEV_BASE_URL = process.env.VUE_APP_API_BASE_URL || "https://test-dbc.platon.uz/";

export const http = axios.create({
  baseURL: isDevelopment ? DEV_BASE_URL : "/",
});

export default {
  install(app) {
    const token = app.config.globalProperties.$keycloak.token;
    http.interceptors.request.use(
      (config) => {
        if (token) config.headers.Authorization = `Bearer ${token}`;
        config.headers.Accept = "application/json";
        config.headers["Access-Control-Allow-Origin"] = "*";
        // config.headers['Content-Type'] = 'application/json'
        return config;
      },
      (error) => Promise.reject(error)
    );
    http.interceptors.response.use(
      (res) => res,
      (error) => {
        // 403 with code -4 ("User is not allowed") is a permission denial, not an expired
        // session: keep the user logged in and let the page's error toast show the message
        const data = error.response?.data;
        // pages pass the error straight to notify, so show the backend's message
        // (e.g. {"message":"project already exists","code":-17}) instead of "AxiosError: ..."
        if (typeof data?.message === "string" && data.message) {
          error.message = data.message;
          error.toString = () => data.message;
        }
        if (error.response?.status === 403 && data?.code === -4) {
          return Promise.reject(error);
        }
        if (
          error.response &&
          (error.response.status === 401 || error.response.status === 403)
        ) {
          TokenService.removeToken();
          app.config.globalProperties.$keycloak.logout();
        }
        return Promise.reject(error);
      }
    );

    app.config.globalProperties.$http = http;
  },
};
